const phone = {
  prefix: '33',
  visualPrefix: '0',
  visualFormatRegex: /(\d{2})(\d{2})(\d{2})(\d{2})(\d+)$/,
  visualFormatRegexDisplay: '$1 $2 $3 $4 $5'
}

export default phone
